import { categories } from "@/mocks/categories";

const featureColumns = [
  {
    title: "Sneakers & Apparel",
    description: "The most comprehensive sneaker and clothing comparison tables updated daily.",
    image: "https://readdy.ai/api/search-image?query=Premium%20grey%20suede%20sneakers%20and%20folded%20beige%20linen%20shirt%20artfully%20arranged%20on%20a%20light%20wooden%20floor%2C%20soft%20morning%20sunlight%20streaming%20through%20a%20large%20window%2C%20minimalist%20editorial%20photography%20with%20organic%20shadows%2C%20Scandinavian%20interior%20aesthetic&width=800&height=600&seq=feature-v2-sneakers&orientation=landscape",
    categories: ["Shoes", "Jackets", "Jersey"],
  },
  {
    title: "Hoodies & Tops",
    description: "Trending hoodies, sweaters, and t-shirts that are taking over social media.",
    image: "https://readdy.ai/api/search-image?query=Terracotta%20colored%20chunky%20knit%20hoodie%20and%20cream%20cotton%20tee%20draped%20over%20a%20rattan%20chair%2C%20warm%20golden%20hour%20sunlight%2C%20Mediterranean%20balcony%20setting%20with%20potted%20olive%20tree%2C%20editorial%20lifestyle%20photography%20with%20rich%20textures&width=600&height=400&seq=feature-v2-hoodies&orientation=landscape",
    categories: ["Hoodies/Sweaters", "T-Shirts", "Sets"],
  },
  {
    title: "Bags & Accessories",
    description: "Complete your look with curated bags, belts, perfumes, and accessories.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20leather%20tote%20bag%20with%20gold%20watch%20and%20slim%20brown%20belt%20arranged%20on%20a%20white%20marble%20surface%2C%20soft%20natural%20daylight%20from%20above%2C%20editorial%20still%20life%20photography%2C%20luxurious%20minimalist%20composition%20with%20high%20detail&width=600&height=400&seq=feature-v2-accessories&orientation=landscape",
    categories: ["Accessories", "Bags", "Belts", "Perfumes"],
  },
];

export default function FeatureGrid() {
  const getCategoryUrls = (catNames: string[]) => {
    return catNames.map((name) => {
      const cat = categories.find((c) => c.name === name);
      return cat || null;
    }).filter(Boolean);
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start justify-between mb-14 gap-6">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-layout-grid-line"></i>
              Organized for You
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Every Style,
              <br />
              Perfectly Sorted
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-xs leading-relaxed lg:pt-3">
            Organized categories for every style — from streetwear to luxury, find exactly what you
            need in seconds.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {featureColumns.map((col, idx) => (
            <div
              key={col.title}
              className={`rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden ${
                idx === 0 ? "lg:row-span-1" : ""
              }`}
            >
              <div className={`${idx === 0 ? "aspect-[4/3]" : "aspect-[3/2]"} overflow-hidden`}>
                <img
                  src={col.image}
                  alt={col.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {col.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed mb-4">
                  {col.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {getCategoryUrls(col.categories).map((cat) =>
                    cat ? (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        {cat.name}
                      </a>
                    ) : null
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}